import { ReactElement, useCallback, useMemo } from 'react';
import {
  Stack,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from '@mui/material';
import { useFormikContext } from 'formik';

import { ORDER_CENTRALIZATION_TRANSFER_OPTIONS } from '~constants/businessProfiles';

import { useBusinessProfileTabsFormContext } from '../../BusinesProfileTabsFormContext';
import { FIELDS_NAMES, initialValues } from '../../utils';

const BusinessProfileOrderCentralizationTransfer = (): ReactElement => {
  const { handleNextTab, handleGoBack } = useBusinessProfileTabsFormContext();

  const { values, getFieldProps, setFieldValue } =
    useFormikContext<typeof initialValues>();

  const orderCentralizationTransferValue = useMemo(
    () => values[FIELDS_NAMES.ORDER_CENTRALIZATION_TRANSFER],
    [values],
  );

  const onGoBack = useCallback(() => {
    setFieldValue(FIELDS_NAMES.ORDER_CENTRALIZATION_TRANSFER, '');
    handleGoBack('orderCentralizationTransfer');
  }, [handleGoBack, setFieldValue]);

  const onNextTab = useCallback(() => {
    handleNextTab('descriptionConfirm');
  }, [handleNextTab]);

  const isDisabledNextButton = useMemo(
    () => !orderCentralizationTransferValue,
    [orderCentralizationTransferValue],
  );

  return (
    <Stack spacing={2} flex={1} justifyContent="space-between">
      <Stack spacing={1}>
        <Typography variant="subtitle1" fontWeight="bold">
          Respecto a la centralización de las órdenes:
        </Typography>

        <Typography variant="subtitle2">
          ¿A dónde llevan las órdenes que han centralizado en su almacén?
        </Typography>

        <RadioGroup
          {...getFieldProps(FIELDS_NAMES.ORDER_CENTRALIZATION_TRANSFER)}
        >
          {ORDER_CENTRALIZATION_TRANSFER_OPTIONS.map((option) => (
            <FormControlLabel
              key={`order-centralization-transfer-${option.value}`}
              value={option.value}
              control={<Radio />}
              label={option.label}
            />
          ))}
        </RadioGroup>
      </Stack>

      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <Button variant="outlined" color="secondary" onClick={onGoBack}>
          Regresar
        </Button>

        <Button
          variant="outlined"
          color="primary"
          onClick={onNextTab}
          disabled={isDisabledNextButton}
        >
          Continuar
        </Button>
      </Stack>
    </Stack>
  );
};

export default BusinessProfileOrderCentralizationTransfer;
